import { call, put } from 'redux-saga/effects'
import { getInterviewRequestOffers, postInterviewRequestOffer } from '../apiModules/interviewRequestOffers'
import { interviewRequestOfferEntities } from '../reducks'

export function* fetchInterviewRequestOfferEntitiesSaga(interviewRequestId) {
  const response = yield call(getInterviewRequestOffers, interviewRequestId)
  yield put(interviewRequestOfferEntities.addCollection(response.result))
  return response
}

export function* createInterviewRequestOfferEntitySaga(interviewRequestId, data) {
  const response = yield call(postInterviewRequestOffer, interviewRequestId, data)
  yield put(interviewRequestOfferEntities.addItem(response.result.id, response.result))
  return response
}
